export const PICKSTATUSLOOKUP = ["Possible", "Implement", "Challenge", "Kill"];
export const CompletionPlanStatus = ["Not Started", "In Progress", "Completed"];

export const CONFIG = {
    A3_EXPERIMENT: {
      showBorders: true,
      rowAlternationEnabled: true,
      allowColumnReordering: true,
      allowColumnResizing: true,
      columnResizingMode: "widget",
      columnAutoWidth: true,
      columnChooser: {
        enabled: true,
        allowSearch: true,
        mode: "select",
      },
  
      headerFilter: {
        visible: true,
      },
      sorting: {
        mode: "row",
      },
      grouping: {
        contextMenuEnabled: true,
      },
      // searchPanel: {
      //   visible: true,
      // },
      filterRow: {
        visible: true,
        applyFilter: "auto",
      },
      /*  paging: {
                pageSize: 10
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [5, 10, 20, 50],
                showInfo: true
            },
            */
      export: {
        enabled: true,
        fileName: "Rapid_Experiment",
      },
      editing: {
        mode: "batch",
        allowUpdating: true,
        allowAdding: true,
        allowDeleting: true,
        useIcons: true,
      },
      /*onRowPrepared: function (e) {
              if (e.rowType == 'data' && e.data.Role == 'Owner') {
                  e.rowElement.find("td").css('backgroundColor', 'rgb(191, 217, 156)');
              }
              else if (e.rowType == 'data' && e.data.Role == 'Alternate') {
                  e.rowElement.find("td").css('backgroundColor', 'rgb(241, 226, 177)');
              }
              else {
                  return false;
              }
          },
          */
      // onToolbarPreparing: function (e) {
      //   var dataGrid = e.component;
      //   var toolbarItems = e.toolbarOptions.items;
      //   // Adds a new item
      //   toolbarItems.unshift(
      //     {
      //       location: "before",
      //       template: "",
      //     },
      //     {
      //       location: "after",
      //       widget: "dxButton",
      //       options: {
      //         icon: "refresh",
      //         hint: "Refresh",
      //         onClick: function () {
      //           dataGrid.refresh();
      //         },
      //       },
      //     }
      //   );
      // },
    },
  };
